module.exports = __webpack_public_path__ + "media/images/bg/octagon-75057d479c02c9b975e18449ea91f22b.svg";